import { SET_STORE_ERROR } from '../actions/types';

export default function storeError(state = '', action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_STORE_ERROR:
				return action.payload;

			// no default
		}
	}

	return state;
}
